import { Component, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { APP_BRAND } from './core/config';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App {
  private readonly title = inject(Title);

  constructor() {
    effect(() => {
      this.title.setTitle(APP_BRAND.appName);
    });
  }
}
